import { http } from '@/utils/http.util';

export default class referralService {
   async getReferralByJourneyAndReferralId(journeyId: Number, referralCode: String) {
      return await http.get('/api/referral/' + journeyId + '/' + referralCode).then((response) => {
         return response.data;
      });
   }
}
